import chalk from "chalk";
import { CONFIGS } from "../configs";

export const isValidPlatform = (platform: string) => {
  if (![CONFIGS.ANDROID, CONFIGS.IOS].includes(platform)) {
    console.error(chalk.red(`\n\n❌ Invalid platform. Use '${CONFIGS.ANDROID}' or '${CONFIGS.IOS}'.\n\n`));
    process.exit(1);
  }
}

export const isValidVersion = (release: string) => {
  if (!release || !/^\d+\.\d+\.\d+$/.test(release)) {
    console.error(chalk.red("\n\n❌ Invalid release version format. Use 'x.x.x'\n\n"));
    process.exit(1);
  }
}

export const isValidPatch = (patch: string) => {
  if (!patch || !/^\d+\.\d+\.\d+_v\d+$/.test(patch)) {
    console.error(chalk.red("\n\n❌ Invalid patch format. Use 'x.x.x_vx'\n\n"));
    process.exit(1);
  }
}
